import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import ExperienceCard from '../Cards/ExperienceCard';
import { experiences } from '../../data/constants';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 40px 0px 80px 0px;
    @media (max-width: 960px) {
        padding: 0px;
    }
    @media (max-width: 600px) {
        padding: 0px 0px 24px 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 80px 0;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
        padding: 24px 0;
    }
    @media (max-width: 600px) {
        padding: 12px 0;
        gap: 6px;
    }
`;

const Title = styled.h2`
    font-size: 42px;
    text-align: center;
    font-weight: 600;
    margin-top: 20px;
    color: ${({ theme }) => theme.text_primary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 32px;
    }
`;

const Desc = styled.p`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

const TimelineSection = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: relative;
    .MuiTimeline-root {
        margin: 0 auto;
        padding: 0;
    }
    .MuiTimelineItem-root {
        min-height: 120px;
    }
    .MuiTimelineContent-root {
        display: flex;
        justify-content: flex-end;
        width: 50%;
    }
    @media (max-width: 900px) {
        .MuiTimelineItem-root {
            flex-direction: row !important;
        }
        .MuiTimelineContent-root {
            width: 100%;
            justify-content: flex-end;
            padding-left: 24px;
            padding-right: 0;
        }
        .MuiTimelineSeparator-root {
            margin-left: 0;
            margin-right: auto;
        }
    }
`;

const Experience = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 900);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Container id="experience">
            <Wrapper>
                <Title>Experience</Title>
                <Desc>
                    Around 1 year of industry experience across software engineering and development internships.
                </Desc>
                <TimelineSection>
                    <Timeline position={isMobile ? "right" : "alternate"}>
                        {experiences.map((experience, idx) => (
                            <TimelineItem
                                key={experience.id || idx}
                                position={isMobile ? "right" : (idx % 2 === 0 ? "left" : "right")}
                            >
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color="secondary" />
                                    {idx !== experiences.length - 1 && <TimelineConnector style={{ background: '#854CE6' }} />}
                                </TimelineSeparator>
                                <TimelineContent
                                    sx={{
                                        py: '12px',
                                        px: 2,
                                        display: 'flex',
                                        justifyContent: isMobile ? 'flex-end' : (idx % 2 === 0 ? 'flex-end' : 'flex-start'),
                                        width: { xs: '100%', sm: '50%' },
                                    }}
                                >
                                    <ExperienceCard experience={experience} />
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                </TimelineSection>
            </Wrapper>
        </Container>
    );
};

export default Experience;
